
document.addEventListener('DOMContentLoaded',()=> {
  let interval = setInterval(()=> {
    if(document.querySelector(".product__info-wrapper .ruk_rating_snippet") && document.querySelector(".product__info-wrapper .ruk-rating-snippet-count")){
      const review = document.querySelector(".product__info-wrapper .ruk_rating_snippet").querySelectorAll('i');
      const text = document.querySelector(".product__info-wrapper .ruk-rating-snippet-count").innerHTML;
      const content =  text.split(" ");
      let total_value=0;
      for(const item of review)
      {
        total_value += parseInt(item.className.replace("ruk-icon-percentage-star--",""));
      }
      total_value/=100;
      if( document.getElementsByClassName("abtest_main-product-total")[0]) {
        document.getElementsByClassName("abtest_main-product-total")[0].innerHTML = `(${content[0].replace("(","")})`;
        document.getElementsByClassName("abtest_main-product-rating")[0].innerHTML = total_value.toString();
        document.querySelector('.abtest_main-product-total-with-rating').classList.remove('hidden')
        clearInterval(interval)
      }
      if( document.querySelector('.abtest_main-product-total-with-rating')){
        document.querySelector('.abtest_main-product-total-with-rating').addEventListener('click',  ()=> {
          if(document.querySelector('reviewsio-product-reviews-widget'))
          scroll(0,document.querySelector('reviewsio-product-reviews-widget').offsetTop - 50)
        })
      }
    }
  }, 1000)
})